import React, { useRef } from "react";
import { Container, Graphics } from "@pixi/react";
import { Settings } from "../../../settings";
import BasicTexture from "../../../Elements/Textures/BasicTexture";
import FreeSpinCounter from "../../../Components/UI/FreeSpinCounter/FreeSpinCounter";
import FeatureWinsDisplay from "../../../Components/UI/FeatureWinsDisplay/FeatureWinsDisplay";

const FreeSpinReelsetBackground = ({ dimensions, symbolSize, children }) => {
  const maskRef = useRef(null);

  return (
    <Container
      name="FreeSpinReelSetBackground"
      position={{ x: dimensions.width / 2, y: dimensions.height / 2 }}
      zIndex={1}
      sortableChildren
    >
      <FreeSpinCounter
        y={-symbolSize * 2}
        x={0}
        zIndex={3}
        symbolSize={symbolSize}
      />
      {/* Back frame: Renders the background frame of the reel set */}
      <BasicTexture
        textureName="reelFrameBack"
        width={symbolSize * Settings.REEL_COUNT}
        height={symbolSize * Settings.SYMBOLS_VISIBLE}
        zIndex={2}
      />
      {/* Mask: Used to clip the contents of the reels to a specific area */}
      <Graphics
        ref={maskRef}
        draw={(g) => {
          g.clear();
          g.beginFill(0xffffff);
          g.drawRect(
            -(symbolSize * Settings.REEL_COUNT) / 2,
            -(symbolSize * Settings.SYMBOLS_VISIBLE) / 2,
            symbolSize * Settings.REEL_COUNT,
            symbolSize * Settings.SYMBOLS_VISIBLE
          );
          g.endFill();
        }}
      />
      {/* Reels: Container for the reel elements, masked by the Graphics component */}
      <Container
        name={"FreeSpinReelSetContainer"}
        mask={maskRef.current}
        x={0}
        y={0}
        sortChildren
        zIndex={3}
      >
        {children}
      </Container>
      {/* Front frame: Renders the front frame of the reel set, slightly larger for a border effect */}
      <BasicTexture
        textureName="featureReelFrameFront"
        width={symbolSize * 1.027 * Settings.REEL_COUNT}
        height={symbolSize * 1.04 * Settings.SYMBOLS_VISIBLE}
        zIndex={3}
      />

      <FeatureWinsDisplay
        width={symbolSize * Settings.REEL_COUNT}
        height={symbolSize}
        zIndex={5}
        y={symbolSize * Settings.SYMBOLS_VISIBLE - symbolSize}
        x={0}
      />
    </Container>
  );
};
export default FreeSpinReelsetBackground;
